<template>
  <div class="product-review w-[calc(100%-2rem)] mx-auto">
    <!-- 产品信息卡片 -->
    <div class="bg-white rounded-lg p-3 mb-2">
      <div class="flex items-start space-x-4">
        <!-- 产品图片 -->
        <img :src="imageBaseUrl + detailInfo.picUrl" class="w-20 h-20 rounded-lg flex-shrink-0" />
        <!-- 产品信息 -->
        <div class="flex-1">
          <div class="flex items-center justify-between">
            <h3 class="text-base font-medium mb-2">{{ detailInfo.type }} - {{ isZh ? detailInfo.place : detailInfo.placeEn }}</h3>
            <span class="text-xs text-gray-500">{{ detailInfo.favoriteCount }}{{ $t("home.favoriteCount") }}</span>
          </div>

          <!-- 评分 -->
          <div class="flex items-center mb-2">
            <van-rate v-model="detailInfo.score" readonly size="14" color="#ffd21e" void-color="#eee" />
            <span class="ml-2 text-sm font-medium">{{ detailInfo.score }}</span>
          </div>

          <!-- 评价统计 -->
          <div class="flex items-center justify-between text-sm text-gray-500">
            <span>{{ detailInfo.commentCount }} {{ $t("products.reviewCount") }}</span>
            <span class="text-[#ff7a00]" @click="showAllReviews">{{ $t("products.showAll") }} ></span>
          </div>
        </div>
      </div>

      <!-- 产品特点标签 -->
      <div class="mt-4">
        <div class="flex flex-wrap">
          <div v-for="feature in (isZh ? detailInfo.commentTags : detailInfo.commentTagsEn)" :key="feature" class="flex items-center mr-6 mb-2">
            <div class="w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center mr-2">
              <van-icon name="success" size="12" color="white" />
            </div>
            <span class="text-xs text-gray-600">{{ feature }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 用户评价 -->
    <div class="bg-white rounded-lg py-3 px-4">
      <div v-if="reviews.length > 0">
        <div v-for="review in reviews" :key="review.id" class="last:mb-0">
          <!-- 用户信息 -->
          <div class="flex items-center mb-2">
            <!-- <img :src="imageBaseUrl + review.countryIcon" class="w-6 h-6 rounded-full mr-2 border border-gray-200" alt="" /> -->
            <div class="w-6 h-6 rounded-full mr-2 text-xs bg-orange-300 text-white leading-6 text-center align-middle">
              {{ firstLetter(review.userNickname) }}
            </div>
            <span class="text-sm font-medium">{{ review.userNickname }}</span>
            <van-rate v-model="review.scores" readonly size="12" color="#ffd21e" void-color="#eee" class="ml-2" />
          </div>

          <!-- 评价内容 -->
          <div class="text-sm text-gray-700 mb-2 leading-relaxed">
            <!-- <span v-if="review.content && review.content.length > 20">
                  {{ review.isExpanded ? review.content : review.content.substring(0, 20) + "..." }}
                </span> -->
            <div>
              <div class="text-sm text-gray-700 mb-1 leading-relaxed">{{ review.content }}</div>
              <div class="text-xs text-gray-400">{{ formatDate(review.createTime) }}</div>
            </div>
          </div>

          <!-- 展开/收起按钮 -->
          <!-- <div v-if="review.content && review.content.length > 20" class="mb-2 flex items-center justify-between">
                <div class="text-xs text-[#ff7a00]" @click="toggleReview(review)">
                  {{ review.isExpanded ? $t("products.showLess") : $t("products.showMore") }}
                </div>
                <div class="text-xs text-gray-400">{{ formatDate(review.createTime) }}</div>
              </div> -->

          <!-- 分割线 -->
          <van-divider v-if="review.id !== reviews[reviews.length - 1].id" />
        </div>
        <div class="text-[#ff7a00] text-center" @click="showAllReviews">{{ $t("products.showAll") }} >></div>
      </div>
      <!-- 无数据提示 -->
      <div v-if="!reviews.length && !loading" class="text-center text-gray-500 py-4">
        {{ $t("common.noData") }}
      </div>
    </div>
  </div>
</template>

<script>
import { Divider, Rate, PullRefresh, List } from "vant"
import { mapGetters } from "vuex"
import dayjs from "dayjs"
import { getProductReview } from "@/apis/shop"
export default {
  name: "ProductReview",
  components: {
    [Divider.name]: Divider,
    [Rate.name]: Rate,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
  },
  props: {
    detailInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      isZh: "lang/isZh",
    }),
    imageBaseUrl() {
      return process.env.VUE_APP_IMAGE_URL
    },
  },
  data() {
    return {
      productFeatures: ["网速快", "网络覆盖广", "物超所值", "使用便捷", "容易激活"],
      // 评价列表分页
      reviews: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageNo: 1,
      pageSize: 10,
      total: 0,
    }
  },
  methods: {
    // 格式化时间戳
    formatDate(timestamp) {
      return dayjs(timestamp).format("YYYY-MM-DD")
    },
    toggleReview(review) {
      this.$set(review, "isExpanded", !review.isExpanded)
    },
    // 下拉刷新
    onRefresh() {
      this.pageNo = 1
      this.finished = false
      this.reviews = []
      this.fetchReviews()
    },
    // 上拉加载
    onLoad() {
      this.fetchReviews()
    },
    // 获取评价列表
    async fetchReviews() {
      if (!this.detailInfo || !this.detailInfo.id) {
        this.loading = false
        this.refreshing = false
        return
      }

      if (this.finished) return

      this.loading = true
      try {
        const params = {
          spuId: this.detailInfo.id,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
        const res = await getProductReview(params)
        const data = res.data || {}
        const list = data.list || []
        const total = data.total || 0

        if (this.refreshing) {
          this.reviews = list
          this.refreshing = false
        } else {
          this.reviews = [...this.reviews, ...list]
        }

        this.total = total
        this.loading = false

        if (this.reviews.length >= this.total || !list.length) {
          this.finished = true
        } else {
          this.pageNo++
        }
      } catch (error) {
        this.loading = false
        this.refreshing = false
      }
    },
    showAllReviews() {
      this.$router.push({
        path: "/productsDetailReviews",
        query: {
          id: this.detailInfo.id,
        },
      })
    },
    firstLetter(name) {
      const firstLetter = name.slice(0, 1).toUpperCase()
      console.log("firstLetter :>> ", firstLetter)
      return firstLetter
    },
  },
  watch: {
    // detailInfo 加载完成后拉取第一页评价
    detailInfo: {
      immediate: true,
      handler(val) {
        if (val && val.id) {
          this.pageNo = 1
          this.finished = false
          this.reviews = []
          this.fetchReviews()
        }
      },
    },
  },
}
</script>

<style scoped>
::v-deep .van-rate__item {
  margin-right: 2px;
}

::v-deep .van-button--mini {
  height: 24px;
  padding: 0 8px;
  font-size: 11px;
}
</style>
